import { useEffect } from 'react'

import { useEchoClient } from './echoClient'

import { useChatStore } from '@/stores/chatStore'

import { useAuthStore } from '@/stores/authStore'

import { playChatSound } from '@/utils/chatSound'

import type { ChatMessage, ChatReactionAggregate } from '@/api/chat'



const ECHO_DEBUG =

  import.meta.env.DEV || String(import.meta.env.VITE_ECHO_DEBUG || '') === 'true'



function echoDevLog(...args: unknown[]) {

  if (ECHO_DEBUG) {

    console.info('[Echo chat]', ...args)

  }

}



interface MessagePayload {

  message: ChatMessage

}



interface ReadMarkPayload {

  chat_room_id: number

  user_id: number

  last_read_message_id: number

}



interface ReactionPayload {

  chat_room_id: number

  message_id: number

  reactions: ChatReactionAggregate[]

  reactions_version?: number

}



/**

 * Подписка на private-каналы chat.{roomId} для всех комнат пользователя.

 * События: chat.message.created|updated|deleted, chat.room.read_mark_updated.

 */

export function useChatRealtime() {

  const roomIdsKey = useChatStore((s) =>

    s.rooms

      .map((room) => room.id)

      .sort((a, b) => a - b)

      .join(',')

  )

  const currentUserId = useAuthStore((s) => s.user?.id ?? 0)



  // Клиент — зависимость эффекта: после пересоздания Echo подписка иначе

  // осталась бы на отключённом сокете.

  const echo = useEchoClient()



  useEffect(() => {

    if (!roomIdsKey) return



    const roomIds = roomIdsKey.split(',').map((id) => Number(id))

    const channelNames = roomIds.map((id) => `chat.${id}`)

    const store = useChatStore.getState



    channelNames.forEach((channelName) => {

      const channel = echo.private(channelName)



      channel

        .listen('.chat.message.created', (payload: MessagePayload) => {

          const message = payload.message

          store().applyIncomingMessage(message)



          const room = store().rooms.find((r) => r.id === message.chat_room_id)

          if (

            message.author_user_id !== currentUserId &&

            room &&

            !room.is_muted &&

            store().currentRoomId !== message.chat_room_id

          ) {

            playChatSound()

          }

        })

        .listen('.chat.message.updated', (payload: MessagePayload) => {

          store().applyUpdatedMessage(payload.message)

        })

        .listen('.chat.message.deleted', (payload: MessagePayload) => {

          store().applyDeletedMessage(payload.message)

        })

        .listen('.chat.room.read_mark_updated', (payload: ReadMarkPayload) => {

          store().applyReadMark(

            payload.chat_room_id,

            payload.user_id,

            payload.last_read_message_id

          )

        })

        .listen('.chat.message.reaction_updated', (payload: ReactionPayload) => {

          store().applyRealtimeReactionUpdate(

            payload.chat_room_id,

            payload.message_id,

            payload.reactions,

            payload.reactions_version

          )

        })



      echoDevLog(`Подписка на private-${channelName}`)

    })



    return () => {

      channelNames.forEach((channelName) => {

        try {

          echo.leave(channelName)

        } catch {

          // ignore

        }

      })

    }

  }, [roomIdsKey, currentUserId, echo])

}


